import React, { Component } from 'react';

const localeSwitchEventType = `locale::switch`

class LocaleSwitcher extends Component {
    constructor(props) {
        super(props);
    }

    switchLocale(locale) {
        const { id } = this.props;
        const event = new CustomEvent(localeSwitchEventType, {
            detail: { locale }
        });
        if (typeof window !== 'undefined') {
            window.dispatchEvent(event);
        }
    }

    getDivider(index, total) {
        if (index < total) { return <div className="level-item">/</div>; } return null;
    }

    render() {
        const { currentLocale, locales } = this.props;
        return (
            <div className="level">
                {locales.map((locale, index) => [<button onClick={() => this.switchLocale(locale)} className={`level-item${currentLocale === locale ? ' is-active' : ''}`}>{locale.toUpperCase()}</button>, this.getDivider(index, locales.length - 1)])}
            </div>
        )
    }
}

export default LocaleSwitcher;


// WEBPACK FOOTER //
// ./src/components/LocaleSwitcher.js